"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DynamicConfig_1 = __importDefault(require("./DynamicConfig"));
var ErrorBoundary_1 = __importDefault(require("./ErrorBoundary"));
var Layer_1 = __importDefault(require("./Layer"));
var StatsigIdentity_1 = __importDefault(require("./StatsigIdentity"));
var StatsigLogger_1 = __importDefault(require("./StatsigLogger"));
var StatsigNetwork_1 = __importDefault(require("./StatsigNetwork"));
var StatsigSDKOptions_1 = __importDefault(require("./StatsigSDKOptions"));
var EvaluationMetadata_1 = require("./EvaluationMetadata");
var StatsigLocalStorage_1 = __importDefault(require("./utils/StatsigLocalStorage"));
var LogEvent_1 = __importDefault(require("./LogEvent"));
var Evaluator_1 = __importDefault(require("./Evaluator"));
var StickyValuesStorage_1 = __importDefault(require("./utils/StickyValuesStorage"));
var StatsigClient = /** @class */ (function () {
    function StatsigClient(sdkKey, options) {
        var _this = this;
        this._initCalled = false;
        this._pendingInitPromise = null;
        this._logLayerParameterExposureForLayer = function (layer, parameterName, isManualExposure) {
            var _a;
            if (isManualExposure === void 0) { isManualExposure = false; }
            var allocatedExperiment = '';
            var exposures = layer._undelegatedSecondaryExposures;
            var isExplicit = layer._explicitParameters.includes(parameterName);
            if (isExplicit) {
                allocatedExperiment = (_a = layer._allocatedExperimentName) !== null && _a !== void 0 ? _a : '';
                exposures = layer._secondaryExposures;
            }
            _this._logger.logLayerExposure(layer._user, layer._name, layer._ruleID, exposures, allocatedExperiment, parameterName, isExplicit, layer._evaluationDetails, isManualExposure);
        };
        if ((options === null || options === void 0 ? void 0 : options.localMode) !== true && typeof sdkKey !== 'string') {
            console.error('Invalid key provided. You must use a Client SDK Key from the Statsig console to initialize the sdk');
        }
        this._errorBoundary = new ErrorBoundary_1.default(sdkKey);
        this._ready = false;
        this._options = new StatsigSDKOptions_1.default(options);
        StatsigLocalStorage_1.default.disabled = this._options.disableLocalStorage;
        StickyValuesStorage_1.default.storageInterface = this._options.userPersistentStorage;
        this._identity = new StatsigIdentity_1.default(sdkKey, this._options.overrideStableID);
        this._errorBoundary._setStatsigMetadata(this._identity._statsigMetadata);
        this._network = new StatsigNetwork_1.default(this._options, this._identity, this._errorBoundary);
        this._logger = new StatsigLogger_1.default(this._options, this._identity, this._network, this._errorBoundary);
        this._evaluator = new Evaluator_1.default(this._options);
        if (this._options.initializeValues != null) {
            this._delayedSetup();
        }
    }
    StatsigClient.prototype.initializeAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this._errorBoundary._capture('initializeAsync', function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (this._pendingInitPromise != null) {
                                        return [2 /*return*/, this._pendingInitPromise];
                                    }
                                    if (this._ready) {
                                        return [2 /*return*/, Promise.resolve({
                                                success: true,
                                                message: 'Client is already initialized.',
                                            })];
                                    }
                                    this._initCalled = true;
                                    if (this._options.localMode) {
                                        return [2 /*return*/, Promise.resolve({
                                                success: true,
                                                message: 'Client is in local mode.',
                                            })];
                                    }
                                    this._pendingInitPromise = this._fetchAndSaveValues(this._options.initTimeoutMs);
                                    return [4 /*yield*/, this._pendingInitPromise];
                                case 1:
                                    _a.sent();
                                    this._ready = true;
                                    this._delayedSetup();
                                    return [2 /*return*/, { success: true }];
                            }
                        });
                    }); }, function () {
                        _this._ready = true;
                        _this._initCalled = true;
                        _this._delayedSetup();
                        return Promise.resolve({
                            success: false,
                            message: 'An error occurred while initializing',
                        });
                    })];
            });
        });
    };
    StatsigClient.prototype.initialize = function (initializeValues) {
        var _this = this;
        return this._errorBoundary._capture('initialize', function () {
            _this._ready = true;
            _this._initCalled = true;
            _this._evaluator.setInitializeValues(initializeValues, EvaluationMetadata_1.EvaluationReason.Bootstrap);
            return {
                success: true,
            };
        }, function () {
            return {
                success: false,
                message: 'An error occurred while parsing initialize values',
            };
        });
    };
    StatsigClient.prototype.getEvaluationDetails = function () {
        var _this = this;
        return this._errorBoundary._capture('getEvaluationDetails', function () {
            return _this._evaluator.getGlobalEvaluationDetails();
        }, function () {
            return {
                time: Date.now(),
                reason: EvaluationMetadata_1.EvaluationReason.Error,
            };
        });
    };
    /**
     * Checks the value of a gate for the current user
     * @param {string} gateName - the name of the gate to check
     * @returns {boolean} - value of a gate for the user. Gates are "off" (return false) by default
     */
    StatsigClient.prototype.checkGate = function (user, gateName, options) {
        var normalizedUser = this._normalizeUser(user);
        return this._checkGateImpl(normalizedUser, gateName, options);
    };
    StatsigClient.prototype.getFeatureGateEvaluation = function (user, gateName) {
        var normalizedUser = this._normalizeUser(user);
        return this._checkGateImpl(normalizedUser, gateName);
    };
    StatsigClient.prototype.logGateExposure = function (user, gateName) {
        var _this = this;
        this._errorBoundary._swallow('logGateExposure', function () {
            var normalizedUser = _this._normalizeUser(user);
            _this._logGateExposureImpl(normalizedUser, gateName);
        });
    };
    /**
     * Checks the value of a config for the current user
     * @param {string} configName - the name of the config to get
     * @returns {DynamicConfig} - value of a config for the user
     */
    StatsigClient.prototype.getConfig = function (user, configName) {
        var normalizedUser = this._normalizeUser(user);
        return this._getConfigImpl(normalizedUser, configName);
    };
    StatsigClient.prototype.logConfigExposure = function (user, configName) {
        var _this = this;
        this._errorBoundary._swallow('logConfigExposure', function () {
            var normalizedUser = _this._normalizeUser(user);
            _this._logConfigExposureImpl(normalizedUser, configName);
        });
    };
    StatsigClient.prototype.getExperiment = function (user, experimentName, options) {
        var normalizedUser = this._normalizeUser(user);
        return this._getConfigImpl(normalizedUser, experimentName, options);
    };
    StatsigClient.prototype.logExperimentExposure = function (user, experimentName) {
        var normalizedUser = this._normalizeUser(user);
        this.logConfigExposure(normalizedUser, experimentName);
    };
    StatsigClient.prototype.getLayer = function (user, layerName, options) {
        var normalizedUser = this._normalizeUser(user);
        return this._getLayerImpl(normalizedUser, layerName, options);
    };
    StatsigClient.prototype.logLayerParameterExposure = function (user, layerName, parameterName) {
        var _this = this;
        this._errorBoundary._swallow('logLayerParameterExposure', function () {
            var normalizedUser = _this._normalizeUser(user);
            var layer = _this._getLayerEvaluation(normalizedUser, null, layerName);
            _this._logLayerParameterExposureForLayer(layer, parameterName, true);
        });
    };
    StatsigClient.prototype.logEvent = function (user, eventName, value, metadata) {
        var _this = this;
        if (value === void 0) { value = null; }
        if (metadata === void 0) { metadata = null; }
        this._errorBoundary._swallow('logEvent', function () {
            var normalizedUser = _this._normalizeUser(user);
            if (typeof eventName !== 'string' || eventName.length === 0) {
                return;
            }
            var event = (0, LogEvent_1.default)(eventName, normalizedUser, _this._identity._statsigMetadata, value, metadata);
            _this._logger.log(event);
        });
    };
    StatsigClient.prototype.loadUserPersistedValues = function (user, idType) {
        var _this = this;
        return this._errorBoundary._capture('shutdown', function () {
            if (_this._options.userPersistentStorage == null) {
                console.error('No user persistent storage set.  loadUserPersistedValues will noop');
                return null;
            }
            var persistedValue = StickyValuesStorage_1.default.getAll(user, idType);
            if (persistedValue == null) {
                return {};
            }
            return persistedValue;
        }, function () {
            return {};
        });
    };
    StatsigClient.prototype.loadUserPersistedValuesAsync = function (user, idType) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this._errorBoundary._capture('shutdown', function () { return __awaiter(_this, void 0, void 0, function () {
                        var asyncValue;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (this._options.userPersistentStorage == null) {
                                        console.error('No user persistent storage set.  loadUserPersistedValuesAsync will noop');
                                        return [2 /*return*/, null];
                                    }
                                    return [4 /*yield*/, StickyValuesStorage_1.default.getAsync(user, idType)];
                                case 1:
                                    asyncValue = _a.sent();
                                    if (asyncValue == null) {
                                        return [2 /*return*/, {}];
                                    }
                                    return [2 /*return*/, asyncValue];
                            }
                        });
                    }); }, function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, {}];
                        });
                    }); })];
            });
        });
    };
    /**
     * Informs the statsig SDK that the client is closing or shutting down
     * so the SDK can clean up internal state
     */
    StatsigClient.prototype.shutdown = function () {
        var _this = this;
        this._errorBoundary._swallow('shutdown', function () {
            _this._logger.shutdown();
        });
    };
    /**
     * @returns The Statsig stable ID used for device level experiments
     */
    StatsigClient.prototype.getStableID = function () {
        var _this = this;
        return this._errorBoundary._capture('getStableID', function () { return _this._identity._stableID; }, function () { return ''; });
    };
    StatsigClient.prototype.initializeCalled = function () {
        return this._initCalled;
    };
    // Private
    StatsigClient.prototype._delayedSetup = function () {
        var _this = this;
        this._errorBoundary._swallow('delayedSetup', function () {
            _this._identity.saveStableID();
            _this._logger.sendSavedRequests().then(function () {
                /* noop */
            });
        });
    };
    StatsigClient.prototype._normalizeUser = function (user) {
        var userCopy = {};
        try {
            userCopy = JSON.parse(JSON.stringify(user));
        }
        catch (error) { }
        if (this._options.environment != null) {
            userCopy = __assign(__assign({}, userCopy), { statsigEnvironment: this._options.environment });
        }
        if (userCopy.customIDs == null) {
            userCopy.customIDs = {};
        }
        if (userCopy.customIDs.stableID == null) {
            userCopy.customIDs.stableID = this.getStableID();
        }
        return userCopy;
    };
    StatsigClient.prototype._getEvaluationDetailsForError = function () {
        return {
            time: Date.now(),
            reason: EvaluationMetadata_1.EvaluationReason.Error,
        };
    };
    StatsigClient.prototype._fetchAndSaveValues = function (timeout) {
        if (timeout === void 0) { timeout = this._options.initTimeoutMs; }
        return __awaiter(this, void 0, void 0, function () {
            var values;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._network.fetchValues(timeout)];
                    case 1:
                        values = _a.sent();
                        this._evaluator.setInitializeValues(values, EvaluationMetadata_1.EvaluationReason.Network);
                        return [2 /*return*/, { success: true }];
                }
            });
        });
    };
    StatsigClient.prototype._checkGateImpl = function (user, gateName, options) {
        var _this = this;
        return this._errorBoundary._capture('checkGate', function () {
            var result = _this._getGateEvaluation(user, gateName);
            if (!(options === null || options === void 0 ? void 0 : options.disableExposureLogging)) {
                _this._logGateExposureImpl(user, gateName, result);
            }
            return result.value === true;
        }, function () { return false; });
    };
    StatsigClient.prototype._getGateEvaluation = function (user, gateName) {
        return this._evaluator.checkGate(user, gateName);
    };
    StatsigClient.prototype._logGateExposureImpl = function (user, gateName, fetchResult) {
        var isManualExposure = !fetchResult;
        var result = fetchResult !== null && fetchResult !== void 0 ? fetchResult : this._getGateEvaluation(user, gateName);
        this._logger.logGateExposure(user, gateName, result.value, result.rule_id, result.secondary_exposures, result.evaluation_details, isManualExposure);
    };
    StatsigClient.prototype._getConfigImpl = function (user, configName, options) {
        var _this = this;
        return this._errorBoundary._capture('getConfig', function () {
            var result = _this._getConfigEvaluation(user, configName, options);
            if (!(options === null || options === void 0 ? void 0 : options.disableExposureLogging)) {
                _this._logConfigExposureImpl(user, configName, result);
            }
            return result;
        }, function () { return _this._getEmptyConfig(configName); });
    };
    StatsigClient.prototype._getConfigEvaluation = function (user, configName, options) {
        var evaluation = this._evaluator.getConfig(user, configName, options);
        return new DynamicConfig_1.default(configName, evaluation.json_value, evaluation.rule_id, evaluation.group_name, evaluation.evaluation_details, evaluation.secondary_exposures, this._makeOnConfigDefaultValueFallback(user));
    };
    StatsigClient.prototype._logConfigExposureImpl = function (user, configName, config) {
        var isManualExposure = !config;
        var localConfig = config !== null && config !== void 0 ? config : this._getConfigEvaluation(user, configName);
        this._logger.logConfigExposure(user, configName, localConfig._ruleID, localConfig._secondaryExposures, localConfig._evaluationDetails, isManualExposure);
    };
    StatsigClient.prototype._makeOnConfigDefaultValueFallback = function (user) {
        var _this = this;
        return function (config, parameter, defaultValueType, valueType) {
            if (!_this._initCalled) {
                return;
            }
            _this._logger.logConfigDefaultValueFallback(user, "Parameter ".concat(parameter, " is a value of type ").concat(valueType, ".\n          Returning requested defaultValue type ").concat(defaultValueType), {
                name: config._name,
                ruleID: config._ruleID,
                parameter: parameter,
                defaultValueType: defaultValueType,
                valueType: valueType,
            });
        };
    };
    StatsigClient.prototype._getLayerImpl = function (user, layerName, options) {
        var _this = this;
        return this._errorBoundary._capture('getLayer', function () {
            var logFunc = (options === null || options === void 0 ? void 0 : options.disableExposureLogging)
                ? null
                : _this._logLayerParameterExposureForLayer;
            return _this._getLayerEvaluation(user, logFunc, layerName, options);
        }, function () {
            return Layer_1.default._create(user, layerName, {}, '', _this._getEvaluationDetailsForError());
        });
    };
    StatsigClient.prototype._getLayerEvaluation = function (user, logParameterFunction, layerName, options) {
        var _a, _b;
        var result = this._evaluator.getLayer(user, layerName, options);
        return Layer_1.default._create(user, layerName, result.json_value, result.rule_id, result.evaluation_details, logParameterFunction, result.secondary_exposures, result.undelegated_secondary_exposures, result.config_delegate, (_a = result.explicit_parameters) !== null && _a !== void 0 ? _a : [], (_b = result.group_name) !== null && _b !== void 0 ? _b : null);
    };
    StatsigClient.prototype._getEmptyConfig = function (configName) {
        return new DynamicConfig_1.default(configName, {}, '', null, this._getEvaluationDetailsForError());
    };
    return StatsigClient;
}());
exports.default = StatsigClient;
